import { OreTableCell, OreTableHead, OreTableRow } from '@edenredespana/oreneta'
import { TableHeadersModel } from '@/Shared/domain/models/TableHeadersModel'

type TableHeadProps = {
  tableHeaders: TableHeadersModel[]
}

export const TableHead = ({ tableHeaders }: TableHeadProps): JSX.Element => (
  <OreTableHead>
    <OreTableRow hover={false}>
      {tableHeaders.map((header: TableHeadersModel) => (
        <OreTableCell as="th" key={header.key} size={header.size}>
          {header.label}
        </OreTableCell>
      ))}
    </OreTableRow>
  </OreTableHead>
)
